import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
export default function TermsPageMobile() {
  const [termsContent, setTermsContent] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch terms content from API
    const fetchTerms = async () => {
      try {
        const response = await fetch(`${API_ORIGIN}/admin-api/cms/content`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ slug: "terms-and-conditions" }),
        });
        const data = await response.json();
        setTermsContent(data.data?.page?.content || "No content found.");
      } catch {
        setTermsContent("Failed to load Terms & Conditions.");
      }
      setLoading(false);
    };
    fetchTerms();
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem("termsAccepted", "true");
    localStorage.setItem("termsAccepted", "true");
    navigate("/signup");
  };

  return (
    <div className="w-full max-w-3xl mb-auto mx-auto px-4 sm:px-6 py-6">
      <h1 className="text-2xl font-bold mb-4">Terms & Conditions</h1>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="prose" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsContent) }} />
      )}
      {/* <button
        className="mt-6 px-6 py-2 bg-[#095228] text-white rounded"
        onClick={handleAccept}
      >
        Accept & Continue
      </button> */}
    </div>
  );
}